<template>
  <div v-if="eligibleForDiscountPromotion" class="promo-notification-box">
    <img class="icon" :src="require('@/assets/discount-benefit.svg')">
    <div class="text-container">
      <div class="first-line bold">מגיע לך חודש ללא חיוב מתנה!</div>
      <div class="more">לקוחות דיסקונט? נרשמים לשירות עם אחד מ<span class="bold">כרטיסי האשראי של דיסקונט</span> ומקבלים חודש מנוי ראשון במתנה.</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PromoNotificationBox',
  computed: {
    ...mapState('promotions', ['eligibleForDiscountPromotion']),
  },
};
</script>

<style scoped lang="scss">
@import "~base-ui/src/scss/riseup-colors";

.promo-notification-box {
  display: flex;
  padding: 20px 15px;
  border-radius: 8px;
  width: 100%;
  background-color: #97e0ae;
  font-size: 14px;
  line-height: 1.36;

  .icon {
    width: 30px;
    height: 30px;
    margin-left: 15px;
  }

  .text-container {
    .first-line {
      margin-bottom: 5px;
    }

    .bold {
      font-weight: bold;
    }
  }
}

</style>
